import { Injectable } from '@angular/core';
import { Router, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SessionService } from '../common/session.service';

@Injectable()
export class SessionGuard implements CanActivateChild {
  constructor(
    private router: Router,
    private session: SessionService,
  ) {}

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return this.session.smartCheck().then(() => {
      return true;
    }, () => {
      this.router.navigateByUrl('/login');
      return false;
    })
  }
}



// WEBPACK FOOTER //
// /srv/src/app/auth/session-guard.service.ts